import React from 'react';
import HtmlFieldWithLimit from '../components/HtmlFieldWithLimit';
import { getFieldLabel } from '../utils/formHelpers';

const HtmlField = ({ field, data, change, hasError, errorMessage, editorKey = '' }) => (
    <HtmlFieldWithLimit
        key={editorKey ? `${field.key}-${editorKey}` : field.key}
        label={getFieldLabel(field)}
        tooltip={field.tooltip}
        value={data[field.key] || ''}
        onChange={(value) => change(field.key, value)}
        maxLen={field.maxLength}
        hasError={hasError}
        errorMessage={errorMessage}
    />
);

export default HtmlField;
